import React from "react";
import { Link } from "react-router-dom";
import { InstallFooterCard } from "./InstallPrompt";
import { useI18n } from "../i18n";

// TODO: remplacer par tes vrais liens/pseudos réseaux sociaux
const SOCIALS = [
  { key: "instagram", label: "Instagram", icon: "fa-brands fa-instagram", href: "https://www.instagram.com/stufflivraisonfrance?igsh=MXZiemlkcDVlaTlzcA%3D%3D&utm_source=qr", color: "hover:text-[#E1306C]" },
  { key: "tiktok", label: "TikTok", icon: "fa-brands fa-tiktok", href: "https://www.tiktok.com/@stuff5230?_r=1&_t=ZN-97rPysZtekQ", color: "hover:text-white" },
  { key: "snapchat", label: "Snapchat", icon: "fa-brands fa-snapchat", href: "https://snapchat.com/t/6VjWbSHH", color: "hover:text-[#FFFC00]" },
  { key: "telegram", label: "Telegram", icon: "fa-brands fa-telegram", href: "https://t.me/+HLjgPk5685k5OTRk", color: "hover:text-[#229ED9]" },
];

export function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-zinc-800 bg-ink mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col sm:flex-row justify-between gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/stuff-logo.png" alt="STUFF CBD" className="h-10 w-10 object-contain drop-shadow-[0_0_8px_rgba(157,255,0,0.4)]" />
              <span className="font-anton text-xl text-white">STUFF</span>
              <span className="font-graffiti text-neon-magenta">cbd</span>
            </div>
            <p className="text-zinc-500 text-sm max-w-xs mb-4">{t("footer.tagline")}</p>
            <div className="flex items-center gap-3" data-testid="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.key}
                  data-testid={`social-${s.key}`}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  className={`h-10 w-10 flex items-center justify-center border border-zinc-800 bg-ink-surface text-zinc-400 transition-all hover:border-neon-green hover:-translate-y-0.5 ${s.color}`}
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>
          <div className="text-zinc-500 text-xs max-w-sm space-y-2">
            <p className="text-neon-green font-semibold uppercase text-xs">{t("footer.info")}</p>
            <div className="flex flex-col gap-1" data-testid="footer-legal">
              <Link to="/blog" data-testid="footer-blog" className="hover:text-neon-green transition-colors">Blog</Link>
              <Link to="/mentions-legales" className="hover:text-neon-green transition-colors">{t("footer.legal")}</Link>
              <Link to="/cgv" className="hover:text-neon-green transition-colors">{t("footer.terms")}</Link>
              <Link to="/confidentialite" className="hover:text-neon-green transition-colors">{t("footer.privacy")}</Link>
              <Link to="/fidelite" className="hover:text-neon-green transition-colors">{t("footer.track")}</Link>
              <Link to="/contact" data-testid="footer-contact" className="hover:text-neon-green transition-colors">{t("footer.contact")}</Link>
            </div>
            <p className="pt-2">{t("footer.disclaimer")}</p>
          </div>
          <InstallFooterCard />
        </div>
        <div className="border-t border-zinc-900 mt-8 pt-6 text-center text-zinc-600 text-xs">
          © {new Date().getFullYear()} STUFF CBD — Plus. Relax. Repeat.
        </div>
      </div>
    </footer>
  );
}
